export const SET_MANAGER_LIST = 'SET_MANAGER_LIST'
export const SET_BACKUP_MANAGER_INFO = 'SET_BACKUP_MANAGER_INFO'
export const SET_SELECTED_MANAGER_INFO = 'SET_SELECTED_MANAGER_INFO'
export const SET_SELECTED_MANAGER_DEPARTMENT = 'SET_SELECTED_MANAGER_DEPARTMENT'
export const SET_SELECTED_MANAGER_EMAIL = 'SET_SELECTED_MANAGER_EMAIL'
export const SET_SELECTED_MANAGER_NOTE = 'SET_SELECTED_MANAGER_NOTE'
export const SET_SELECTED_MANAGER_PHONE = 'SET_SELECTED_MANAGER_PHONE'
export const SET_SELECTED_MANAGER_POSITION_ID =
  'SET_SELECTED_MANAGER_POSITION_ID'
export const SET_SELECTED_MANAGER_NUMBER = 'SET_SELECTED_MANAGER_NUMBER'
export const SET_SEARCH_FORM = 'SET_SEARCH_FORM'
export const SET_COMPLAIN_LIST = 'SET_COMPLAIN_LIST'
export const SET_PAGING = 'SET_PAGING'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_DRIVER_LIST = 'SET_DRIVER_LIST'
export const SET_TYPE_LIST = 'SET_TYPE_LIST'
export const SET_IS_SEARCH_BTN_LOADING = 'SET_IS_SEARCH_BTN_LOADING'
export const SET_IS_TABLE_LOAGING = 'SET_IS_TABLE_LOAGING'
export const SET_CURRENT_LOGIN_SERVICE_ID = 'SET_CURRENT_LOGIN_SERVICE_ID'
export const SET_IS_ADD_COMPLAIN_DIALOG = 'SET_IS_ADD_COMPLAIN_DIALOG'
export const SET_IS_ADD_EVENT_DIALOG = 'SET_IS_ADD_EVENT_DIALOG'
export const SET_IS_UPDATE_COMPLAIN_DIALOG = 'SET_IS_UPDATE_COMPLAIN_DIALOG'
export const SET_UPDATE_COMPLAIN_DIALOG = 'SET_UPDATE_COMPLAIN_DIALOG'
export const SET_UPDATE_COMPLAIN_ID = 'SET_UPDATE_COMPLAIN_ID'
export const SET_TEAM_ROLES = 'SET_TEAM_ROLES'



// WEBPACK FOOTER //
// ./src/store/managerStore/mutation-types.js